/* index.js */

"use strict";
const DatePicker = require("./DatePicker/DatePickerComponent");
const DateTimePicker = require("./DateTimePicker/DateTimePickerComponent");

module.exports = {
    DatePicker: DatePicker,
    DateTimePicker: DateTimePicker,
};
